import {Component, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {PerformaModulesService} from "src/app/services/performa-modules.service";
import {AuthService} from "src/app/services/auth.service";

@Component({
    selector: "app-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileComponent implements OnInit {
    mustChangePass = false;
    mustSetEmail = false;
    force2fa = false;
    enrolled = false;

    constructor(
        private authService: AuthService,
        private modules: PerformaModulesService
    ) {}

    @Input() tab = "info";

    origTabs = [
        {tab: "info", name: "User Information"},
        {tab: "email", name: "Email"},
        {tab: "password", name: "Change Password"},
        {tab: "two-factor", name: "Two-Factor"}
    ];

    tabs = [...this.origTabs];

    async ngOnInit() {
        this.tabs = this.origTabs;
        this.mustChangePass = this.authService.mustChangePass;
        this.mustSetEmail = this.authService.mustSetEmail;
        this.enrolled = this.authService.twoFactorEnabled;
        this.force2fa = this.modules.features.some((x: string) => x.toLowerCase() === "force2fa");

        // if they need to set 2FA, only do it if they don't also need to set
        // password and email first (in that order)
        if (this.mustChangePass) {
            this.tab = "password";
            this.tabs = this.tabs.filter(x => x.tab == "password");
        } else if (this.mustSetEmail) {
            this.tab = "email";
            this.tabs = this.tabs.filter(x => x.tab == "email");
        } else if (!this.mustChangePass && !this.mustSetEmail && this.force2fa && !this.enrolled) {
            this.tab = "two-factor";
            this.tabs = this.tabs.filter(x => x.tab == "two-factor");
        } else {
            if (!this.tab) this.tab = "info";
        }
    }

    getClass = (tab: string) => {
        if (tab === this.tab) {
            return "active";
        }
        return "";
    };

    getTab = (tab: string) => {
        return this.tabs.find(x => x.tab === tab);
    };
}
